export const getLocalizedString = (
  uriFr: string,
  uriEn: string,
  locale: string,
  defautLocale: string
): string => {
  if (locale === defautLocale) return uriFr;
  return uriEn;
};
